module.exports = __webpack_public_path__ + "img/CMHK_02_zhTc.932df4fd.png";